<template>
    <v-navigation-drawer app v-model="drawer" 
        :permanent="!isMobile"
        class="secondary" clipped floating>
        <v-layout column fill-height>
            <br>
            
            <v-list>
                <v-list-tile v-for="item in items" :key="item.title" :to="{path: item.path}">
                    <v-list-tile-action>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title v-text="$t('views.'+item.title)"></v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
            <v-spacer></v-spacer> 
            <div class="bottom-logo-holder">
                <img :src="require('@/assets/Logo_Horitzontal_Negre.png')" style="width:80%!important;display:block;margin:auto;"><br>
                <div style="width:80%;margin:auto;color:black;font-size:9px;">© 2026 Institut Català de Paleontologia Miquel Crusafont</div>
            </div>         
        </v-layout>
    </v-navigation-drawer>
</template>

<script>

export default {
    name: 'Drawer',
    data: function(){
        return{
            currentDate:null,
            dialog:false,
        };
    },
    computed: {
        info () {
            return this.$store.state.app.title + ' v' + this.$store.state.app.version
        },
        drawer: {
            get () {
                return this.$store.state.app.drawer
            },
            set (val) {
                this.$store.commit('drawer', val)
            }
        },
        items () {
            let vm = this;
            let list = [];
            vm.$router.options.routes.forEach(route => {
                if (vm.$store.state.auth.token && route.meta.secure && route.meta.main) {
                    list.push({
                        title: route.meta.title,
                        icon: route.meta.icon,
                        path: route.path
                    })
                } else if (!vm.$store.state.auth.token && !route.meta.secure && route.meta.main) {
                    list.push({
                        title: route.meta.title,
                        icon: route.meta.icon,
                        path: route.path
                    })
                }
            })
            return list;
        }
    },
    mounted:function(){
        let vm=this;
        vm.currentDate = new Date();
        setInterval(function(){
            vm.currentDate = new Date();
        },10000);
    }
}
</script>

<style>
    i.v-icon.material-icons.theme--light {
        max-width: 25px;
    }
    .v-navigation-drawer a{
        color:black;
        text-decoration: none;
        font-weight: 500;
        font-size:20px;
    }
    .bottom-logo-holder{
        height:160px;
        opacity:0.7;
    }
    @media(max-width:1000px){
        .bottom-logo-holder{
            position:relative;
            top:-80px;
        }
    }
</style>